import { useTranslation } from 'react-i18next';
import { Button, CheckCircleLineIcon, Col, RightLine, Row, Text, Title } from 'ui';
import type { Consent, ConsentOption } from '../../../types';

type P = {
  onChange?: (data: Consent) => void;
  onSelect: (option: ConsentOption) => void;
  value?: Consent;
};

const ConsentsFormItem = ({ onChange, onSelect, value }: P) => {
  const { t } = useTranslation();

  return (
    <Row align="middle" className="consents-form-item">
      <Col flex={1}>
        <Title className="consents-form-item__title" level={5} marginBottom>
          {value?.name}
        </Title>
      </Col>
      <Col>
        <Button
          onClick={() => {
            if (value && onChange) {
              onSelect({ onChange, value });
            }
          }}
          size="large"
          type="link-primary"
        >
          {value?.consented ? (
            <Text type="success">
              {t('Confirmed')} <CheckCircleLineIcon />
            </Text>
          ) : (
            <>
              {t('Confirm')} <RightLine />
            </>
          )}
        </Button>
      </Col>
    </Row>
  );
};

export default ConsentsFormItem;
